import { CircularCountdown, ReadyIcon, Spinner } from 'components/shared/PriceNext';
import { FC, ReactNode } from 'react';
import type { ExposedFormStatus } from 'state/forms/models';

export interface FormStatusIconProps {
  status?: ExposedFormStatus;
  e2e?: string;
}

export const FormStatusIcon: FC<FormStatusIconProps> = ({ status, e2e }) => {
  return <>{getIconFromStatus(status, e2e)}</>;
};

function getIconFromStatus(status?: ExposedFormStatus, e2e?: string): ReactNode {
  switch (status) {
    case 'NotReady':
      return (
        <i className="icon icon-sm me-2 text-muted" data-e2e={e2e ?? 'form-status-icon'}>
          filter_tilt_shift
        </i>
      );
    case 'Ready':
      return (
        <i className="icon icon-sm me-2 text-info" data-e2e={e2e ?? 'form-status-icon'}>
          <ReadyIcon dotColor="info" />
        </i>
      );
    case 'Deleting':
    case 'Duplicating':
    case 'InProgress':
    case 'Patching':
    case 'Validating':
      return (
        <i className="icon icon-sm me-2 text-muted" data-e2e={e2e ?? 'form-status-icon'}>
          {Spinner}
        </i>
      );
    case 'Success':
      return (
        <div className="icon icon-xs me-2" data-e2e={e2e ?? 'form-status-icon'}>
          {CircularCountdown}
        </div>
      );
    case 'Expired':
      return (
        <i className="icon icon-sm me-2" data-e2e={e2e ?? 'form-status-icon'}>
          history_toggle_off
        </i>
      );
    case 'UnknownError':
    case 'Rejected':
      return (
        <i className="icon icon-sm me-2 text-danger" data-e2e={e2e ?? 'form-status-icon'}>
          block
        </i>
      );
    case 'ActionFailed':
      return (
        <i className="icon icon-sm me-2 text-warning" data-e2e={e2e ?? 'form-status-icon'}>
          block
        </i>
      );
    case 'Warning':
      return (
        <i className="icon icon-sm me-2 text-warning" data-e2e={e2e ?? 'form-status-icon'}>
          block
        </i>
      );
    default:
      return (
        <i className="icon icon-sm me-2 text-primary" data-e2e={e2e ?? 'form-status-icon'}>
          {Spinner}
        </i>
      );
  }
}
